/**
 * Türkçe sözlük · bicim: sayı, tarih, tür etiketleri ve değerleme damgaları
 * (`lib/decimal.ts`, `lib/format.ts`, `lib/valuationText.ts`).
 */
export const bicim = {
  /** Yüzde işaretinin yeri: Türkçede sayının önünde. */
  yuzde: (govde: string) => `%${govde}`,
  bilinmiyor: "bilinmiyor",
  sinifiBilinmiyor: "sınıfı bilinmiyor",

  sayiHatasi: {
    EMPTY: "Bir sayı girin.",
    BAD_CHARS: "Yalnızca rakam, nokta ve virgül kullanın.",
    BAD_GROUPING: "Binlik ayırıcılar üçlü gruplar hâlinde olmalı.",
    AMBIGUOUS: "Ondalık ayırıcı birden fazla kez yazılmış.",
    TOO_MANY_DECIMALS: "En fazla 12 ondalık hane girilebilir.",
    TOO_LARGE: "Sayı çok büyük (en fazla 18 tam hane).",
    INVALID: "Geçersiz sayı.",
  },

  hesapTuru: {
    araci_kurum: "Aracı kurum",
    banka: "Banka",
    cuzdan: "Cüzdan",
    borsa: "Borsa",
    fiziki: "Fiziki",
  },

  hareketTuru: {
    BUY: "Alış",
    SELL: "Satış",
    DIVIDEND: "Temettü",
    INTEREST: "Faiz",
    SPLIT: "Bölünme",
    BONUS: "Bedelsiz",
    RIGHTS: "Bedelli (rüçhan)",
    DEPOSIT: "Para yatırma",
    WITHDRAWAL: "Para çekme",
    FEE: "Masraf / komisyon",
    TRANSFER_IN: "Devir girişi",
    TRANSFER_OUT: "Devir çıkışı",
    TAX_PAYMENT: "Vergi ödemesi",
    FX_CONVERSION: "Döviz alış/satış",
  },
  dovizAlis: "Döviz alış",
  dovizSatis: "Döviz satış",

  varlikSinifi: {
    equity_tr: "BIST hissesi",
    equity_foreign: "Yabancı hisse",
    etf: "Borsa yatırım fonu",
    crypto: "Kripto",
    fund_tr: "Yatırım fonu (TEFAS)",
    commodity: "Kıymetli maden",
    fx: "Döviz",
    deposit: "Mevduat / faiz",
    other: "Diğer",
  },

  /** Değerleme damgaları: etiket ve "ne yapmalıyım". */
  damga: {
    oversold: {
      label: "Elde olmayan miktar satıldı",
      action: "Kasa eksik başlıyor olabilir: açılış devri girilmemiş olabilir.",
    },
    transfer_cost_unknown: {
      label: "Devir maliyeti girilmemiş",
      action: "Maliyet sıfır SAYILMADI; kazanç bu parti için eksik kalır.",
    },
    rescale_without_lots: {
      label: "Dağıtılacak parti yok",
      action: "Bölünme/bedelsiz, açık parti yokken gelmiş. Hareket tarihlerini gözden geçirin.",
    },
    mixed_currency: {
      label: "Aracın partileri farklı para birimlerinde",
      action: "Maliyet parti parti, her partinin kendi tarihinin kuruyla çevrildi.",
    },
    nakit_hareketi_okunamadi: {
      label: "Nakit satırının tutarı okunamadı",
      action:
        "Nakit hareketleri quantity = 1, price = tutar diye kodlanıyor; bu satırda " +
        "çarpım sıfır çıkıyor ama fiyat sıfır değil. O hesabın net hareketi " +
        "hesaplanamıyor — damganın gösterdiği kaydın miktarını düzeltin.",
    },
    nakit_hareketi_cevrilemedi: {
      label: "Nakit rapor para birimine çevrilemedi",
      action:
        "Kovanın KENDİ para birimindeki neti doğru ve görünüyor; bulunamayan " +
        "yalnızca sorulan günün kuru. Kur eşitlemesi bu satırı da tamamlar.",
    },
    para_birimi_taninmiyor: {
      label: "Para birimi kodu tanınmıyor",
      action:
        "Kasaya yazılmış kod kapalı listede yok; kuru aranamaz. Damganın " +
        "gösterdiği kodu düzeltin — düzeltilene kadar bu varlığın maliyeti ve " +
        "kazancı eksik kalır.",
    },
    fiyat_yok: {
      label: "Fiyat yok",
      action: "Sorulan güne kadar hiç fiyat yok. İzleme ekranından eşitleyin ya da elle fiyat girin.",
    },
    kur_yok: {
      label: "Kur yok",
      action: "Değer aracın para biriminde var, rapor para biriminde yok. Kur eşitlemesi gerekiyor.",
    },
    elle_deger_yok: {
      label: "Elle değer girilmemiş",
      action: "Bu varlık için ne birim fiyat ne toplam değer var. Elle değerleme ekranından girin.",
    },
    para_birimi_celiskisi: {
      label: "Para birimi çelişkisi",
      action: "Fiyatın para birimi hareketlerinkinden farklı. Araç bağlaması yanlış olabilir.",
    },
    elle_fiyat_yoksayildi: {
      label: "Elle fiyat yok sayıldı",
      action:
        "Bu araç izlemede: günlük fiyatı kaynaktan geliyor ve tektir. Elle girdiğiniz " +
        "fiyat kullanılmadı; kaydı silebilirsiniz.",
    },
    kapali_pozisyon: {
      label: "Kapalı pozisyon",
      action: "Miktar sıfır: değerlenecek bir şey yok, gerçekleşmiş kazanç var.",
    },
    nakit_tutar_okunamadi: {
      label: "Nakit satırının tutarı okunamadı",
      action:
        "Nakit satırı `miktar = 1, fiyat = tutar` diye kodlanır; bu satırda miktar yazılmamış. " +
        "Tutar tahmin EDİLMEDİ — satır nakit akışına girmedi. Hareketi düzeltin.",
    },
    sermaye_hareketi_haric: {
      label: "Sermaye hareketi hariç",
      action: "Para yatırma/çekme getiri değildir; nakit akışına katılmadı.",
    },
    maliyet_eksik: {
      label: "Maliyetin bir kısmı bilinmiyor",
      action: "Kazanç EKSİK; sıfır sayılmadı.",
    },
    kaydedilmemis_temettu: {
      label: "Kaynakta temettü var, kasada yok",
      action: "Temettü aldıysanız DIVIDEND hareketi girin; nakit akışı ve getiri o kadar eksik.",
    },
    kaydedilmemis_bolunme: {
      label: "Kaynakta bölünme var, kasada yok",
      action: "SPLIT hareketi girin: adet bölünme öncesinde kaldığı için piyasa değeri yanlış olabilir.",
    },
    bedelsiz_ruchan_bilinmiyor: {
      label: "Bedelsiz/rüçhan kaynağı yok",
      action:
        "Adet ve maliyet yalnızca kasadaki BONUS/RIGHTS hareketlerine dayanıyor. " +
        "Bedelsiz ya da rüçhan aldıysanız hareketini girin.",
    },
  },

  dayanak: {
    fiyat: "önbellek fiyatı",
    "elle-fiyat": "elle girilen fiyat",
    "elle-deger": "elle girilen toplam değer",
    kur: "kur",
    hareket: "hareketin kendi fiyatı",
  },

  /** "01.10.2026 ölçümüyle · 28.09.2026 bekleniyordu" */
  olcumuyle: (olcum: string, beklenti: string) => `${olcum} ölçümüyle · ${beklenti}`,
  guncellemesiBekleniyordu: (an: string) => `${an} güncellemesi bekleniyordu`,
  bekleniyordu: (gun: string) => `${gun} bekleniyordu`,
  gunBayat: (n: number) => `${n} gün bayat`,
};
